import { withStyles, Card } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { withRouter } from 'react-router';
import PrivacyTermsView from '../components/Footer/PrivacyTermsView.jsx';
import BasicModal from '../components/Modals/BasicModal.jsx';
import { getLuckeyLogoSource, getPlantName, isMobileBrowser } from '../_config/utils';

const styles = theme => ({
  '@keyframes scaleIn': {
    '0%': {
      transform: 'scale(0)',
      opacity: 0,
    },
    '50%': {
      transform: 'scale(1.1)',
    },
    '100%': {
      transform: 'scale(1)',
      opacity: 1,
    }
  },
  '@keyframes pulse': {
    '0%': {
      boxShadow: '0 0 0 0 rgba(244, 67, 54, 0.7)',
    },
    '70%': {
      boxShadow: '0 0 0 20px rgba(244, 67, 54, 0)',
    },
    '100%': {
      boxShadow: '0 0 0 0 rgba(244, 67, 54, 0)',
    }
  },
  root: {
    display: 'flex',
    minHeight: '100vh',
    width: '100%',
    backgroundColor: '#157495',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage: 'url(/imgs/common/loginBackground.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',
    padding: '40px 20px',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(135deg, rgba(21, 116, 149, 0.92), rgba(18, 99, 127, 0.95))',
      zIndex: 0,
    },
  },
  contentCard: {
    position: 'relative',
    zIndex: 1,
    maxWidth: '60%',
    width: '100%',
    padding: '38px',
    borderRadius: '16px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
    backgroundColor: 'rgba(255, 255, 255, 0.98)',
    textAlign: 'center',
  },
  logo: {
    height: '60px',
    marginBottom: '32px',
    display: 'block',
    margin: '0 auto 32px',
  },
  errorIconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '80px',
    height: '80px',
    margin: '0 auto 24px',
    borderRadius: '50%',
    backgroundColor: 'rgba(244, 67, 54, 0.1)',
    animation: '$pulse 2s infinite',
  },
  errorIcon: {
    color: '#f44336',
    fontSize: '48px',
    animation: '$scaleIn 0.5s ease-out',
  },
  errorTitle: {
    fontSize: '28px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '16px',
    marginTop: 0,
  },
  errorDescription: {
    fontSize: '16px',
    color: '#666',
    lineHeight: '1.6',
    marginBottom: '32px',
  },
  plantName: {
    color: '#157495',
    fontWeight: '600',
    fontFamily: 'monospace',
    fontSize: '18px',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '24px',
    paddingTop: '24px',
    borderTop: '1px solid rgba(0, 0, 0, 0.08)',
  },
  footerLogo: {
    height: '14px',
    marginRight: '6px',
  },
  footerText: {
    fontSize: '12px',
    color: '#999',
    margin: 0,
  },
});
@withRouter
class ServiceNotFoundView extends React.Component {

  render() {
    const { classes } = this.props;
    const isMobile = isMobileBrowser();
    const year = new Date().getFullYear();
    const plantName = getPlantName();

    // Mobile version
    if (isMobile) {
      return (
        <div style={{
          minHeight: '100vh',
          width: '100%',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
          WebkitOverflowScrolling: 'touch',
          backgroundColor: '#157495',
        }}>
          <div style={{
            minHeight: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundImage: 'url(/imgs/common/loginBackground.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed',
            padding: '40px 20px',
            position: 'relative',
          }}>
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              minHeight: '100%',
              background: 'linear-gradient(135deg, rgba(21, 116, 149, 0.92), rgba(18, 99, 127, 0.95))',
              zIndex: 0,
              pointerEvents: 'none',
            }} />
            <div style={{
              position: 'relative',
              zIndex: 2,
              width: '100%',
              maxWidth: '400px',
              textAlign: 'center',
            }}>
              <img 
                src="/imgs/common/logoJagoWhite.png" 
                alt="Luckey" 
                style={{
                  height: '50px',
                  marginBottom: '40px',
                  display: 'block',
                  margin: '0 auto 40px',
                }}
              />
              <Card style={{
                padding: '32px 24px',
                borderRadius: '16px',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                backgroundColor: 'rgba(255, 255, 255, 0.98)',
              }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '64px',
                  height: '64px',
                  margin: '0 auto 20px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(244, 67, 54, 0.1)',
                }}>
                  <ErrorOutlineIcon style={{ 
                    color: '#f44336', 
                    fontSize: '40px',
                  }} />
                </div>
                <h1 style={{
                  fontSize: '20px',
                  fontWeight: '600',
                  color: '#333',
                  marginBottom: '12px',
                  marginTop: 0,
                }}>
                  <Entity entity="plantNotFoundTitle" />
                </h1>
                <p style={{
                  fontSize: '14px',
                  color: '#666',
                  lineHeight: '1.6',
                  marginBottom: '16px',
                }}>
                  <Entity entity="plantNotFoundDescription" data={{ plantName: plantName }} />
                </p>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '24px',
                  paddingTop: '24px',
                  borderTop: '1px solid rgba(0, 0, 0, 0.08)',
                }}>
                  <span style={{ fontSize: '12px', color: '#999', margin: 0 }}>Sofia part of ISEO ©{year}</span>
                </div>
              </Card>
            </div>
          </div>
          <BasicModal
            ref={(m) => { this.privacySupportModal = m; }}
            title={<h3 style={{ color: '#3f3f3f', fontWeight: 'bold', margin: 0 }}><Entity entity="privacyInfo" /></h3>}
            body={
              <div>
                <PrivacyTermsView />
              </div>
            }
          />
        </div>
      );
    }

    // Desktop version
    return (
      <div className={classes.root}>
        <Card className={classes.contentCard}>
          <img 
            src="/imgs/common/logoJagoDark.png" 
            alt="Luckey" 
            className={classes.logo}
          />
          <div className={classes.errorIconWrapper}>
            <ErrorOutlineIcon className={classes.errorIcon} />
          </div>
          <h1 className={classes.errorTitle}>
            <Entity entity="plantNotFoundTitle" />
          </h1>
          <p className={classes.errorDescription}>
            <Entity entity="plantNotFoundDescription" data={{ plantName: plantName }} />
          </p>
          <div className={classes.footer}>
            <span className={classes.footerText}>Sofia part of ISEO ©{year}</span>
          </div>
        </Card>
        <BasicModal
          ref={(m) => { this.privacySupportModal = m; }}
          title={<h3 style={{ color: '#3f3f3f', fontWeight: 'bold', margin: 0 }}><Entity entity="privacyInfo" /></h3>}
          body={
            <div>
              <PrivacyTermsView />
            </div>
          }
        />
      </div>
    );
  }
}

export default withStyles(styles)(ServiceNotFoundView);
